import { CategoryConfig } from "../types/config"

export type NormalizedCategory = {
  id: string
  name: string
  slug: string
}

export const normalizeCategories = (categories: CategoryConfig[] = []): NormalizedCategory[] =>
  categories.map(item => ({
    id: item.category.categoryId.toString(),
    name: item.category.categoryName,
    slug: item.category.slug || "",
  }))

export const createCategoriesSignature = (categories: NormalizedCategory[]): string =>
  categories.map(category => `${category.id}:${category.name}`).join("|")
